import { FiCompass } from "react-icons/fi";
import ConstructionMaterial from "../../../assets/assets/Construction Material.png";
import tmtbarcard from "../../../assets/assets/tmtbarcard.png";
import SheetsSection from "./SheetsSection";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ironpipes from "../../../assets/assets/iron-pipes.png";
import miggwire from "../../../assets/assets/migg-wire.png";

export interface SheetsData {
    categoryId: string;
    categoryName: string;
    images: string[];
}
export interface CategoryData {
    categoryId: string;
    categoryName: string;
    totalItemCount: number;
    images: string[];
}

interface Props {
    handleOpen: () => void,
    sheets?: SheetsData[];
    categories: CategoryData[]
}
const CategoriesToExplore = ({ handleOpen, sheets, categories }: Props) => {
    const navigate = useNavigate();
    const handleItemClick = (_id: string | null, name: string | null) => {
        if (_id)
            navigate(`/items/${_id}/category/${name}`, { state: { id: _id } });
        else toast.warning("Something went wrong! Please try again.");
    };

    return (
        <div className="bg-white pt-4">
            <div
                className="flex items-center gap-2 mb-4 justify-center  py-2 "
                style={{
                    background:
                        "linear-gradient(90deg, #FF9300, #FFF500, #FF9300)",
                    backgroundSize: "200% 100%",
                    animation: "borderMove 2s linear infinite",
                }}>
                <FiCompass className="text-black/90 text-lg" />
                <h4 className="text-[14px] font-semibold uppercase text-black/90 tracking-wider">
                    Categories to explore
                </h4>
            </div>

            {/* Image cards */}
            <div className="grid grid-cols-2 gap-4 px-4">
                {categories && categories?.map((category, i) => (
                    <div
                        key={i}
                        onClick={() =>
                            handleItemClick(category?.categoryId, category?.categoryName)
                        }
                        className="bg-gray-100 border border-gray-300 shadow-sm rounded-md overflow-hidden ">
                        <div className="grid grid-cols-2 gap-2 p-2 ">
                            {category?.images?.map((img, index) => (
                                <img
                                    key={index}
                                    src={img}
                                    alt={`Category ${index}`}
                                    className={`h-[80px] w-full bg-white object-contain rounded-md border p-1`}
                                />
                            ))}
                        </div>
                        <div className="relative text-center mt-2 pb-3">
                            <button className="absolute -top-7 left-1/2 transform -translate-x-1/2 px-3 py-[2px] border border-gray-400 bg-white text-gray-600 rounded-full text-[10px] shadow whitespace-nowrap">
                                {`+${category.totalItemCount}`} more
                            </button>
                            <h5 className="text-[12px] font-semibold text-black mt-2">
                                {category.categoryName}
                            </h5>
                        </div>
                    </div>
                ))}
            </div>
            {/* Sheets */}
            <SheetsSection handleOpen={handleOpen} sheets={sheets || []} handleItemClick={handleItemClick} />

            {/* Construction Material Card */}
            <div className="p-4">
                <div className="border shadow-sm border-gray-200 rounded overflow-hidden transition-all p-3">
                    <div className="bg-[#EDF4FF] flex justify-center items-center h-24 rounded">
                        <img
                            src={ConstructionMaterial}
                            alt="Construction Material"
                            className="object-contain mt-3"
                        />
                    </div>
                    <div className="p-3">
                        <h4 className="text-[14px] font-bold text-black mb-1">
                            Construction Material
                        </h4>
                        <p className="text-[12px] text-gray-600 leading-snug">
                            Wide range of construction materials including cement, bricks, sand, and more for all your building needs.
                        </p>
                    </div>
                </div>
            </div>

            {/* More  */}
            <div className="grid grid-cols-2 gap-4 px-4 mt-2 pb-5 ">
                <div className="flex flex-col items-center  " onClick={() => handleItemClick("648820c756407a97becd8a74", "MIGG WIRE")}>
                    <div className="w-full flex justify-center items-center h-[90px] mb-2 border border-gray-200 shadow-sm rounded px-2 ">
                        <img
                            src={miggwire}
                            alt="Iron Pipes"
                            className="object-contain h-full"
                        />
                    </div>
                    <h5 className="text-[13px] font-semibold text-black">
                        MIGG WIRE
                    </h5>
                </div>
                <div className="flex flex-col items-center  " onClick={() => handleItemClick("64884f3cdd9a00806a2a0a4b", "ROUND PIPE")} >
                    <div className="w-full flex justify-center items-center  h-[90px] mb-2 border border-gray-200 shadow-sm rounded px-2 ">
                        <img
                            src={ironpipes}
                            alt="Iron Pipes"
                            className="object-contain h-full"
                        />
                    </div>
                    <h5 className="text-[13px] font-semibold text-black">
                        ROUND PIPE
                    </h5>
                </div>
            </div>

            <div className="py-3">
                <img src={tmtbarcard} alt="" className="w-full" />
            </div>

        </div>
    );
};

export default CategoriesToExplore;
